import { DelayTrigger } from "./delayTrigger";
import { ClickTrigger } from "./clickTrigger";
import { ScrollTrigger } from "./scrollTrigger";
import { SiteTimeTrigger } from "./siteTimeTrigger";
import { ExitIntentTrigger } from "./exitIntentTrigger";
import { ElementOnTrigger } from "./elementOnTrigger";
import { VisitsTrigger } from "./visitsTrigger";
import { VisitedUrls } from "./visitedUrls";
import Action from "../Actions/actionRepository";

export interface Trigger {
    init: (action: Action) => void;
}

export var triggerRepository: { [id: string]: ITriggerDefinition } = {};

export interface ITriggerDefinition {
    trigger: any;
    description: string;
    params: any;
    paramsDescription: any;
}

triggerRepository["delay"] = {
    trigger: DelayTrigger,
    description: "Action kommer att hända efter antal angivna sekunder",
    params: { timeToAction: "" },
    paramsDescription: { timeToAction: "Tid i sekunder." },
}; //timeToAction: number/ milliseconds

triggerRepository["click"] = {
    trigger: ClickTrigger,
    description: "Action kommer att hända efter ett visst antal click",
    params: {
        selector: "",
        clickCount: "",
    },
    paramsDescription: {
        selector: "Skall vara elementets selector",
        clickCount: "Antal click på obj",
    },
}; //elementId: string;

triggerRepository["scroll"] = {
    trigger: ScrollTrigger,
    description: "Action kommer att hända efter att man har scrollat några procent",
    params: { percent: "" },
    paramsDescription: {
        percent: "Hur mycket i % skall man skrolla för att få trigger",
    },
}; // percent: number;

triggerRepository["exitIntent"] = {
    trigger: ExitIntentTrigger,
    description: "Action kommer att hända när man flyttar muspekaren när toolbar",
    params: { dangerZone: "" },
    paramsDescription: { dangerZone: "type:number, Where mouse should go" },
}; //dangerZone: number;

triggerRepository["siteTime"] = {
    trigger: SiteTimeTrigger,
    description: "På en specifik sida",
    params: { timeOnSite: "timeOnSite" },
    paramsDescription: { timeOnSite: "Hur lång tid på sidan" },
}; // timeOnSite: number;

triggerRepository["elementVisible"] = {
    trigger: ElementOnTrigger,
    description: "Action kommmer att hända när första elementet enligt selector kommer in på sidan",
    params: { selector: "" },
    paramsDescription: { selector: "element selector" },
}; //elementId string

triggerRepository["visits"] = {
    trigger: VisitsTrigger,
    description: "action kommer att hända efter ett antal gånger man har besökt sidan",
    params: { count: "" },
    paramsDescription: { count: "Antal gånger på besökt sida" },
}; //count: number

triggerRepository["visitedUrls"] = {
    trigger: VisitedUrls,
    description:
        "Kommaseparerad lista med besökta paths på denna site (ex. /home/42,/home/43,/store), fungerar även med wildcards ( /home/* )",
    params: {
        urls: "",
        count: "",
        id: "",
        delayInSeconds: "",
    },
    paramsDescription: {
        urls: "Arrayer med sites",
        count: "antal besök",
        id: "unique id for this url set",
        delayInSeconds: "number of seconds to wait until action, if set",
    },
};
